"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=room.dto.js.map